import { OPTION_TYPES } from '@nexxt/common/types';
import actionType from '../actions/actionTypes';

export interface IOptionPackReducer {
    initialFetch: boolean;
    optionpacks: IOptionPack[];
    optionpackobject: {
        [id: number]: IOptionPack;
    };
}

export interface IOptionPack {
    id: number;
    label: string;
    value: number;
    availableOptions: IOption[];
    optionType: OPTION_TYPES;
    optionSettings: any;
}

interface IOption {
    altTexts: any[];
    label: string;
    mediaURL?: string;
    optionID: number;
    randomizeOption: boolean;
    tags: string[];
    texts: IOptionLanguage[];
    value: string;
}

interface IOptionLanguage {
    language: string;
    label: string; //title
    text: string;
}

const initialState: IOptionPackReducer = {
    initialFetch: false,
    optionpacks: [],
    optionpackobject: {}
};

export default function (
    state: IOptionPackReducer = initialState,
    action
): IOptionPackReducer {
    switch (action.type) {
        case actionType.GET_ALL_OPTION_PACKS:
            return {
                ...state,
                initialFetch: true,
                optionpacks: action.payload
            };
        case actionType.ADD_SINGLE_OPTION_PACK:
            return {
                ...state,
                optionpacks: state.initialFetch
                    ? [action.payload.data, ...state.optionpacks]
                    : state.optionpacks
            };
        case actionType.GET_SINGLE_OPTION_PACK:
            return {
                ...state,
                [action.payload.id]: action.payload
            };
        default:
            return state;
    }
}
